<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="title-h3 mr-r10">자원</div>
    <el-row style="width:calc(100% - 39px);" :gutter="4">
      <el-col :span="11">
        <el-select v-model="managetypeId" style="width: 100%;">
          <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
        </el-select>
      </el-col>
      <el-col :span="13">
        <el-select style="width: 100%;" v-show="managetypeId=='NMS'||managetypeId=='FMS'||managetypeId=='DBMS'||managetypeId=='VMS'" v-model="managetypeKey">
          <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
        </el-select>
      </el-col>
    </el-row>
  </el-row>
  <hr class="mr-b10" style="margin-top: 0px;" />
  <w-search-field ref="searchField" class="title-bar" width="100%;" @search="filterTree" />
  <el-row>
    <el-tree v-loading="loading" ref="rscTree" :data="rscTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" highlight-current expand-on-click-node :filter-node-method="filterNode" @node-click="clickNode"></el-tree>
  </el-row>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import msgUtil from '@/utils/message';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import { COMMON_KEY } from '@/constants/managetype-key';
import WSearchField from '@/components/form/SearchField';
import TreeFilter from '@/mixins/tree/filter';
import EventSettingsAPI from '@/api/settings/common/event-settings';
import { defaultProps } from '@/constants/tree';

export default {
  name: 'WRscTree',
  mixins: [TreeFilter],
  components: {
    WSearchField,
  },
  props: {
    managetypeList: Array,
  },
  data() {
    return {
      defaultProps,
      loading: false,
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      managetypeKeyList: [],
      selectedNode: null,
      treeRef: 'rscTree',
      rscTreeData: [],
    };
  },
  watch: {
    managetypeList: {
      immediate: true,
      handler(array) {
        if (!isNil(array)) {
          if (isNil(this.managetypeId)) {
            this.managetypeId = array[0].managetypeId;
          }
        }
      },
    },
    managetypeId: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          if (isEqual(value, 'NMS') || isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS')) {
            ManagetypeKeyAPI.getDisplayedManagetypeKeyList(value)
              .then((response) => {
                if (response.data.success === true) {
                  this.managetypeKeyList = response.data.data;
                  this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
                } else {
                  this.managetypeKeyList = null;
                }
              })
              .catch(() => {
                this.managetypeKeyList = null;
              });
          } else {
            this.managetypeKey = COMMON_KEY;
          }
          this.managetypeIdKey = `${value}.${this.managetypeKey}`;
        }
      },
    },
    managetypeKey: {
      immediate: true,
      handler(value) {
        const managetypeId = this.managetypeId;
        this.managetypeIdKey = `${managetypeId}.${value}`;
      },
    },
    managetypeIdKey: {
      immediate: true,
      handler(value) {
        this.selectedNode = null;
        if (!isNil(value)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      this.loading = true;
      EventSettingsAPI.getRscTreeByManagetypeId({
        managetypeId,
        managetypeKey,
      })
        .then((response) => {
          if (response.data.success) {
            this.rscTreeData = response.data.data;
            this.$nextTick(() => {
              if (!isEmpty(this.rscTreeData)) {
                let currentKey;
                if (isNil(this.selectedNode)) {
                  this.clickNode(this.rscTreeData[0]);
                  currentKey = this.rscTreeData[0].treeKey;
                } else {
                  this.clickNode(this.selectedNode);
                  currentKey = this.selectedNode.treeKey;
                }
                this.$refs.rscTree.setCurrentKey(currentKey);
                this.$refs.searchField.clear();
              }
            });
          } else {
            this.failToLoad();
          }
        })
        .catch(() => {
          this.failToLoad();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
    },
    clickNode(nodeData) {
      this.selectedNode = nodeData;
      this.$emit('select-node', this.selectedNode);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/components/RscTree.vue